import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {useSiteContext} from '../../contexts/site'
import {KsLogo} from '../icons'

const LoadingSpinner = ({
    height,
    background,
    position,
    top,
    zIndex = 'overlay',
    displayOverlay = 'block',
    pointerEvents = 'auto'
}) => {
    const {isYR} = useSiteContext()
    return isYR ? (
        <Box
            zIndex={zIndex}
            position={position || 'absolute'}
            top={top || '0px'}
            left="0"
            height={height || '100vh'}
            right="0"
            bottom="0"
            alignContent="center"
            background={background || 'whiteAlpha.600'}
            pointerEvents={pointerEvents}
        >
            <Box className="yr-loading" margin="auto" />
        </Box>
    ) : (
        <Box
            zIndex={zIndex}
            position={position || 'absolute'}
            top={top || '0px'}
            left="0"
            height={height || '100vh'}
            right="0"
            className="ks-spinner-wrapper"
            bottom="0"
            alignContent="center"
            pointerEvents={pointerEvents}
        >
            <Box
                className="underlay"
                sx={{
                    opacity: '0.5',
                    backgroundColor: 'ksSpinnerOverlay5',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%'
                }}
            />
            <Box
                className="spinner-overlay"
                sx={{
                    display: displayOverlay,
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    width: '187px',
                    height: '187px',
                    marginTop: '-94px',
                    marginLeft: '-88px',
                    background: 'ksSpinnerOverlay6',
                    filter: 'blur(35px)'
                }}
            />
            <Box className="ks-spinner">
                <Box className="dot1">
                    <Box
                        width="187px"
                        height="187px"
                        margin="auto"
                        display="flex"
                        justifyContent="center"
                    >
                        <KsLogo height="45px" width="45px" alt="KS Spinner" />
                    </Box>
                </Box>
                <Box className="dot2"></Box>
            </Box>
        </Box>
    )
}

LoadingSpinner.propTypes = {
    height: PropTypes.string,
    zIndex: PropTypes.string,
    position: PropTypes.string,
    top: PropTypes.string,
    displayOverlay: PropTypes.any,
    pointerEvents: PropTypes.string,
    background: PropTypes.string
}

export default LoadingSpinner
